import React, { Component, PropTypes } from 'react';

import './MyoSelectorItem.css';
import SvgIcon from '../components/SvgIcon';
import colors from '../colors';

class MyoSelectorItem extends Component {
  constructor(props) {
    super(props);

    this._handleClick = this._handleClick.bind(this);
  }

  render() {
    let { data, selected } = this.props;
    let style = Object.assign({}, this._getDefaultStyles(), this.props.style);
    let myoIconStyle = { width: 128, height: 128 };
    let detailIconStyle = { marginRight: 4 }
    let selectorIconStyle = { marginLeft: 'auto' };

    let selectorIcon = selected ? 'checked' : 'unchecked'

    return (
      <div className="myo-selector-item flex-row flex-center-items" style={style} onClick={this._handleClick}>
        <SvgIcon icon="myo" style={myoIconStyle} />
        <div className="myo-details flex-column flex-fill">
          <div className="myo-details-line">
            <h2>{ data.name }</h2>
          </div>
          <div className="myo-details-line">
            <SvgIcon icon={ data.synced ? 'synced' : 'unsynced' } style={detailIconStyle} />
            <span>{ data.synced ? 'Synced' : 'Unsynced'}</span>
          </div>
          <div className="myo-details-line">
            <SvgIcon icon="battery" style={detailIconStyle} />
            <span>{ data.batteryLevel }%</span>
          </div>
        </div>
        <SvgIcon icon={selectorIcon} style={selectorIconStyle} />
      </div>
    );
  }

  _getDefaultStyles() {
    let defaultStyle = {
      backgroundColor: colors.white,
      margin: 8,
      padding: 32,
      cursor: 'pointer',
      // shadow copied from material-ui paper element
      boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px'
    };

    return defaultStyle;
  }

  _handleClick() {
    this.props.onSelected(this.props.data);
  }
}

MyoSelectorItem.propTypes = {
  style: PropTypes.object,
  data: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelected: PropTypes.func.isRequired
}

MyoSelectorItem.defaultProps = {
  style: {},
  selected: false
}

export default MyoSelectorItem;



/** WEBPACK FOOTER **
 ** ./src/components/MyoSelectorItem.js
 **/